import './account.css';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, errorText } from '../../api';
import {
  AgbField,
  BANK_ORDER,
  BankFields,
  COMPANY_ORDER,
  companyPayload,
  fieldId,
  FirmFields,
  focusFirstError,
  hasErrors,
  serverErrorField,
  useForm,
  validateCompany,
} from '../../auth/CompanyFields';
import { useSession } from '../../auth/session';
import { t } from '../../i18n';
import { useToast } from '../../lib/toast';
import { usePage } from '../page';

const ORDER = [...COMPANY_ORDER, ...BANK_ORDER, 'unternehmer', 'agb', 'av'];

// Weitere Firma anmelden (gleicher Login). Die Kanzlei prüft sie wie eine Registrierung.
export function AddCompany() {
  usePage({
    title: t('Weitere Firma'),
    back: '/app',
    nav: 'start',
    crumbs: [{ label: t('Übersicht'), to: '/app' }, { label: t('Weitere Firma anmelden') }],
  });
  const { refresh } = useSession();
  const navigate = useNavigate();
  const toast = useToast();
  const f = useForm({});
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    const errors = validateCompany(f.values);
    if (hasErrors(errors)) {
      f.setErrors(errors);
      focusFirstError(ORDER, errors);
      return;
    }
    setBusy(true);
    try {
      const body = companyPayload(f.values);
      await api.post('/api/app/companies', body);
      await refresh();
      toast(t('{name}: Registrierung in Prüfung', { name: body.name }));
      navigate('/app', { replace: true });
    } catch (err) {
      const text = errorText(err);
      const field = serverErrorField(text);
      if (field) {
        f.setErrors({ [field]: text });
        document.getElementById(fieldId(field))?.focus();
      } else setError(text);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="addcompany">
      <div className="hello">
        <h2>{t('Weitere Firma anmelden')}</h2>
        <p>{t('Ihre Kanzlei prüft die Angaben und schaltet die Firma frei. Danach finden Sie sie hier in der App.')}</p>
      </div>
      <form className="form" onSubmit={submit} noValidate>
        <FirmFields f={f} />
        <BankFields f={f} />
        <AgbField f={f} />
        {error && (
          <p className="formerr" role="alert">
            {error}
          </p>
        )}
        <button type="submit" className="btn2 dark" disabled={busy}>
          {busy ? t('Einen Moment …') : t('Firma anmelden')}
        </button>
      </form>
    </div>
  );
}
